var map = {
	"./crm-apps.svg": 63000,
	"./crm-auth.svg": 27763,
	"./crm-card.svg": 1799,
	"./crm-customer.svg": 75383,
	"./crm-drainage.svg": 24246,
	"./crm-group.svg": 93353,
	"./crm-home.svg": 9227,
	"./crm-message.svg": 88420,
	"./crm-more.svg": 61825,
	"./crm-risk.svg": 47201,
	"./crm-stat.svg": 57401,
	"./crm-store.svg": 95420,
	"./crm-task.svg": 96608,
	"./crm-team.svg": 51891,
	"./ebusiness-auth.svg": 43758,
	"./ebusiness-diversion.svg": 33897,
	"./ebusiness-red-packets.svg": 96315,
	"./ebusiness-shop.svg": 11128,
	"./mall-account.svg": 95771,
	"./mall-customer.svg": 81792,
	"./mall-distribution.svg": 60929,
	"./mall-marketing.svg": 38903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11360;